"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = void 0;
const react_1 = __importStar(require("react"));
const types_1 = require("./types");
const Modal_1 = require("./Modal");
function useModal(_a) {
    var { initialActiveState, render, view = types_1.MODAL_VIEW.dialog, overlayColor, containerRef, onClose, hasSidePanelAnimation, onContainerClick } = _a, rest = __rest(_a, ["initialActiveState", "render", "view", "overlayColor", "containerRef", "onClose", "hasSidePanelAnimation", "onContainerClick"]);
    const dataRef = (0, react_1.useRef)();
    const [isActive, setShowState] = (0, react_1.useState)(!!initialActiveState);
    const deactivate = (0, react_1.useCallback)(() => {
        dataRef.current = undefined;
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setShowState(false);
    }, [onClose]);
    const activate = (0, react_1.useCallback)((data) => {
        dataRef.current = data;
        setShowState(true);
    }, []);
    const toggle = (0, react_1.useCallback)((data) => {
        isActive ? deactivate() : activate(data);
    }, [activate, deactivate, isActive]);
    const body = (0, react_1.useMemo)(() => (react_1.default.createElement(Modal_1.Modal, { containerRef: containerRef, isShown: isActive, onRequestClose: deactivate, view: view, overlayColor: overlayColor, hasSidePanelAnimation: hasSidePanelAnimation, "data-selector-id": rest['data-selector-id'], onContainerClick: onContainerClick, render: ({ hide }) => {
            return (render({
                deactivate: hide,
                onRequestClose: hide,
                activate,
                toggle,
                data: dataRef.current,
                isActive
            }) || null);
        } })), [
        containerRef,
        isActive,
        view,
        overlayColor,
        hasSidePanelAnimation,
        rest,
        onContainerClick,
        deactivate,
        render,
        activate,
        toggle
    ]);
    return [body, { deactivate, activate, toggle, isActive }];
}
exports.useModal = useModal;
//# sourceMappingURL=useModal.js.map